import { render, staticRenderFns } from "./clueTabs.vue?vue&type=template&id=3ea55ee2&scoped=true"
import script from "./clueTabs.vue?vue&type=script&lang=js"
export * from "./clueTabs.vue?vue&type=script&lang=js"
import style0 from "./clueTabs.vue?vue&type=style&index=0&id=3ea55ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea55ee2",
  null
  
)

export default component.exports